import React, { Children } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { useTheme } from '../providers/ThemeProvider';
export const PrivacyPolicyPage = () => {
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gradient-to-r from-gray-50 to-gray-100'}`} data-id="element-6030">
      <Navbar data-id="element-6031" />

      {/* Main Content */}
      <div className="pt-20 pb-16" data-id="element-6032">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6033">
          <div className={`${isDark ? 'bg-navy-800' : 'bg-white'} rounded-xl shadow-lg p-8 md:p-12`} data-id="element-6034">
            <h1 className={`text-4xl font-bold mb-8 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6035">
              Privacy Policy
            </h1>

            <div className={`prose prose-lg max-w-none ${isDark ? 'prose-invert' : ''}`} data-id="element-6036">
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6037">
                <strong data-id="element-6038">Effective Date:</strong> January 15, 2025
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6039">
                Maestro Connect ("we," "us," or "our") is committed to
                protecting your privacy. This Privacy Policy explains how we
                collect, use, disclose, and safeguard your information when you
                use our platform and services (collectively, the "Services"). By
                accessing or using the Services, you agree to the terms of this
                Privacy Policy.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6040">
                1. Information We Collect
              </h2>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6041">
                1.1 Information You Provide
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-6042">
                We collect information you provide directly to us, including:
              </p>
              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-6043">
                <li data-id="element-6044">
                  <strong data-id="element-6045">Account Information:</strong> Name, email address,
                  phone number, profile picture, and other registration details.
                </li>
                <li data-id="element-6046">
                  <strong data-id="element-6047">Profile Information:</strong> Teaching credentials,
                  instruments taught, availability, location, and other
                  professional details.
                </li>
                <li data-id="element-6048">
                  <strong data-id="element-6049">Payment Information:</strong> Payment details are
                  processed securely by third-party payment providers, including
                  Paddle. Maestro Connect does not store or have access to full
                  payment card information.
                </li>
                <li data-id="element-6050">
                  <strong data-id="element-6051">Communications:</strong> Messages, feedback, and other
                  communications you send through the Services.
                </li>
                <li data-id="element-6052">
                  <strong data-id="element-6053">Lesson and Practice Data:</strong> Lesson schedules,
                  attendance records, practice logs, progress notes, and other
                  educational content.
                </li>
              </ul>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6054">
                1.2 Information Collected Automatically
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-6055">
                When you use the Services, we automatically collect certain
                information, including:
              </p>
              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-6056">
                <li data-id="element-6057">
                  <strong data-id="element-6058">Device Information:</strong> IP address, browser type,
                  operating system, device identifiers, and mobile network
                  information.
                </li>
                <li data-id="element-6059">
                  <strong data-id="element-6060">Usage Information:</strong> Pages viewed, features
                  used, time spent on the Services, and other usage statistics.
                </li>
                <li data-id="element-6061">
                  <strong data-id="element-6062">Location Information:</strong> Approximate location
                  based on IP address or precise location if you grant
                  permission.
                </li>
                <li data-id="element-6063">
                  <strong data-id="element-6064">Cookies and Tracking Technologies:</strong> We use
                  cookies, web beacons, and similar technologies to collect
                  information about your interactions with the Services.
                </li>
              </ul>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6065">
                1.3 Information from Third Parties
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6066">
                We may receive information about you from third parties, such as
                social media platforms (if you choose to connect your account),
                payment processors, and identity verification services.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6067">
                2. How We Use Your Information
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-6068">
                We use the information we collect to:
              </p>
              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-6069">
                <li data-id="element-6070">Provide, maintain, and improve the Services.</li>
                <li data-id="element-6071">
                  Facilitate connections between teachers and students,
                  including matching and scheduling.
                </li>
                <li data-id="element-6072">
                  Process payments, manage subscriptions, and send transaction
                  confirmations.
                </li>
                <li data-id="element-6073">
                  Communicate with you about your account, lessons, and updates
                  to the Services.
                </li>
                <li data-id="element-6074">
                  Personalize your experience and provide tailored content and
                  recommendations.
                </li>
                <li data-id="element-6075">
                  Monitor and analyze usage trends to improve the Services.
                </li>
                <li data-id="element-6076">
                  Detect, prevent, and address fraud, security issues, and
                  technical problems.
                </li>
                <li data-id="element-6077">
                  Comply with legal obligations and enforce our Terms of
                  Service.
                </li>
                <li data-id="element-6078">
                  Send marketing communications (with your consent, where
                  required).
                </li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6079">
                3. How We Share Your Information
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-6080">
                We do not sell or rent your personal information to third
                parties. We may share your information in the following
                circumstances:
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6081">
                3.1 With Other Users
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6082">
                Teachers and students can view each other's profile information,
                lesson schedules, and communications necessary to facilitate
                lessons.
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6083">
                3.2 With Service Providers
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6084">
                We share information with third-party service providers who
                perform services on our behalf, such as payment processing,
                hosting, analytics, customer support, and marketing.
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6085">
                3.3 For Legal Reasons
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6086">
                We may disclose your information if required by law, legal
                process, or government request, or if we believe disclosure is
                necessary to protect our rights, your safety, or the safety of
                others.
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6087">
                3.4 Business Transfers
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6088">
                If we are involved in a merger, acquisition, or sale of assets,
                your information may be transferred as part of that transaction.
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6089">
                3.5 With Your Consent
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6090">
                We may share your information with third parties when you
                provide explicit consent.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6091">
                4. Data Security
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6092">
                We implement reasonable security measures to protect your
                information from unauthorized access, disclosure, alteration,
                and destruction. However, no method of transmission over the
                internet or electronic storage is 100% secure. While we strive
                to protect your information, we cannot guarantee its absolute
                security.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6093">
                5. Data Retention
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6094">
                We retain your information for as long as necessary to provide
                the Services, comply with legal obligations, resolve disputes,
                and enforce our agreements. When your information is no longer
                needed, we will securely delete or anonymize it.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6095">
                6. Your Rights and Choices
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-6096">
                Depending on your location, you may have the following rights:
              </p>
              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-6097">
                <li data-id="element-6098">
                  <strong data-id="element-6099">Access and Portability:</strong> Request a copy of
                  your personal information.
                </li>
                <li data-id="element-6100">
                  <strong data-id="element-6101">Correction:</strong> Update or correct inaccurate
                  information.
                </li>
                <li data-id="element-6102">
                  <strong data-id="element-6103">Deletion:</strong> Request deletion of your personal
                  information, subject to legal and contractual obligations.
                </li>
                <li data-id="element-6104">
                  <strong data-id="element-6105">Opt-Out:</strong> Unsubscribe from marketing
                  communications by following the instructions in the email or
                  contacting us.
                </li>
                <li data-id="element-6106">
                  <strong data-id="element-6107">Cookie Management:</strong> Adjust your browser
                  settings to refuse cookies or alert you when cookies are being
                  sent.
                </li>
              </ul>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6108">
                To exercise these rights, please contact us at{' '}
                <a href="mailto:privacy@maestroconnect.com" className={`${isDark ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-700'} hover:underline`} data-id="element-6109">
                  privacy@maestroconnect.com
                </a>
                .
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6110">
                7. Children's Privacy
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6111">
                The Services are not intended for children under 13 years of
                age. We do not knowingly collect personal information from
                children under 13. If we learn that we have collected
                information from a child under 13, we will delete it promptly.
                If you believe we have collected information from a child under
                13, please contact us.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6112">
                8. International Data Transfers
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6113">
                Your information may be transferred to and processed in
                countries other than your country of residence. These countries
                may have data protection laws that differ from those in your
                country. By using the Services, you consent to the transfer of
                your information to these countries.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6114">
                9. Third-Party Links
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6115">
                The Services may contain links to third-party websites or
                services. We are not responsible for the privacy practices of
                these third parties. We encourage you to review their privacy
                policies before providing any information.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6116">
                10. Changes to This Privacy Policy
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-6117">
                We may update this Privacy Policy from time to time. If we make
                material changes, we will notify you by email or by posting a
                notice on the Services. Your continued use of the Services after
                the changes take effect constitutes your acceptance of the
                updated Privacy Policy.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6118">
                11. Contact Us
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-6119">
                If you have questions or concerns about this Privacy Policy or
                our data practices, please contact us:
              </p>
              <div className={`${isDark ? 'bg-navy-700' : 'bg-gray-50'} p-6 rounded-lg mb-6`} data-id="element-6120">
                <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-6121">
                  <strong data-id="element-6122">Email:</strong>{' '}
                  <a href="mailto:privacy@maestroconnect.com" className={`${isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'} hover:underline`} data-id="element-6123">
                    privacy@maestroconnect.com
                  </a>
                </p>
              </div>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mt-8`} data-id="element-6124">
                Thank you for trusting Maestro Connect with your information. We
                are committed to protecting your privacy and providing a safe,
                secure platform for music education.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer data-id="element-6125" />
    </div>;
};